/* Copyright 2016-2022
   Kabandy
   Author: Jonathan Boosten
 */

import { ITime, ITimeSerialized } from ".";

export module DocumentDataModel {
    export enum ETargetType {
        Board = 0,
        ModelGroup = 1
    }

    export interface IGenericDocument {
        id: string;
        userId: string;
        projectId: string;
        name?: string;
        targets: any[];
        fileMetadata: {
            name: string;
            contentType: string;
            size: number;
        };
        content: any;
        time: ITime | ITimeSerialized;
    }

    export interface IDocument extends IGenericDocument {
        time: ITime;
    }

    export interface IDocumentSerialized extends IGenericDocument {
        time: ITimeSerialized;
    }

    export module Database {
        export interface ICreateInfo {
            userId: string;
            projectId: string;
            documentId: string;
            targets: { type: number; id: string }[];
            name?: string;
            fileMetadata?: {
                name: string;
                contentType: string;
                size: number;
            };
            content?: any;
        }

        export interface IGetInfo {
            projectId: string;
            documentId: string;
        }
    }

    export module Runtime {
        export interface ICopyInfo {
            userId: string;
            projectIdSrc: string;
            documentIdSrc: string;
            projectIdDest: string;
            boardIdDest: string;
            documentIdDest?: string;
        }
    }

    export module Storage {
        export interface ICopyInfo {
            userId: string;
            projectIdSrc: string;
            documentIdSrc: string;
            projectIdDest: string;
            documentIdDest: string;
        }
    }
}
